import { detourIsRed, detourPinLabel } from '../lib/detour';

type Props = { minutes: number; selected: boolean };

export function DetourPin({ minutes, selected }: Props) {
  const variant = detourIsRed(minutes) ? 'far' : 'near';
  return (
    <div className={`detour-pin detour-pin--${variant}${selected ? ' detour-pin--selected' : ''}`}>
      <span className="detour-pin-label">{detourPinLabel(minutes)}</span>
    </div>
  );
}
